<div class="switch" [ngClass]="{active:value==value1}" (click)="change()">
   <span class="handle">{{value == value1 ? label1 : label0}}</span>
</div>

